import { __extends } from "tslib";
import { PutRecordsInput, PutRecordsOutput } from "../models/index";
import { deserializeAws_json1_1PutRecordsCommand, serializeAws_json1_1PutRecordsCommand, } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var PutRecordsCommand = /** @class */ (function (_super) {
    __extends(PutRecordsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutRecordsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    PutRecordsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var logger = configuration.logger;
        var handlerExecutionContext = {
            logger: logger,
            inputFilterSensitiveLog: PutRecordsInput.filterSensitiveLog,
            outputFilterSensitiveLog: PutRecordsOutput.filterSensitiveLog,
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutRecordsCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1PutRecordsCommand(input, context);
    };
    PutRecordsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1PutRecordsCommand(output, context);
    };
    return PutRecordsCommand;
}($Command));
export { PutRecordsCommand };
//# sourceMappingURL=PutRecordsCommand.js.map